import { useParams } from 'react-router-dom';
import { Menu, MenuItem, Icon } from 'semantic-ui-react';
import { AssetDetails } from './AssetDetails';
import { AssetChecklistViewer } from './AssetChecklistViewer';
import { AssetHistoryList } from './AssetHistoryList';
import { useEffect, useState } from 'react';
import { fetchWithAuth, getCSRFToken } from '../auth';
import { AssetProblems } from './AssetProblems';
import { AssetLifecycle } from './AssetLifecycle';
import { AssetImages } from './AssetImages';
import { AssetMoveHistory } from '../AssetMoveRequests';

export const AssetWrapper = (props) => {
    const { id } = useParams()

    const [chosenElement, setChosenElement] = useState(props.chosenElement ? props.chosenElement : "View")
    const [pageArgs, setPageArgs] = useState({})
    const [needsVerification, setNeedsVerification] = useState(false)
    const [checklistRequired, setChecklistRequired] = useState(false)
    const [isNew, setIsNew] = useState(false)
    const [inspectionImages, setInspectionImages] = useState([])
    const [detailRefreshKey, setDetailRefreshKey] = useState(0)
    const [assetData, setAssetData] = useState(null)

    const setJustVerified = () => {
        setNeedsVerification(false)
    }

    async function getNeedsVerification() {
        const response = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `assets/${id}/`, {
            headers: { 'X-CSRFToken': getCSRFToken() },
            credentials: 'include'
        });
        if (!response.ok) {
            // this will be found again in the full asset pages
            return;
        }
        const data = await response.json();
        setAssetData(data);
        const midnight = new Date()
        midnight.setHours(0, 0, 0, 0)
        const lastVerified = new Date(data['checklistVerifiedOn'])
        setNeedsVerification(lastVerified < midnight)
        setChecklistRequired(data['deviceSubType']['checklistExists'])
        setInspectionImages(data['inspectionImages'] || [])
    }

    function changePage(page, args) {
        setChosenElement(page)
        setPageArgs(args)
    }

    useEffect(() => {
        if(id === "newasset") {
            setIsNew(true)
        } else {
            setIsNew(false)
        }
    }, [id])

    useEffect(() => {
        if(id !== "newasset") {
            getNeedsVerification()
        }
    }, [id])


    useEffect(() => {
        window.history.replaceState(null, "", chosenElement.toLowerCase())
    }, [chosenElement])

    return (
        <>
            <div align="center" style={{ paddingBottom: "0.5rem", overflowX: "auto", marginBottom: "2rem" }}>
                <div style={{ width: "fit-content", minWidth: "min-content" }}>
                    <Menu pointing>
                        <MenuItem content={<><Icon color="grey" className="list" />Details</>} name="View" onClick={() => setChosenElement('View')} active={chosenElement === 'View'} />
                        <MenuItem disabled={isNew} content={<><Icon color="grey" className="history" />Changelog</>} name="Changelog" onClick={() => setChosenElement('Changelog')} active={chosenElement === 'Changelog'} />
                        <MenuItem disabled={isNew || !checklistRequired} style={{ color: needsVerification ? "red" : "" }}
                            content={<><Icon color={needsVerification && checklistRequired ? "red" : "grey"} className="check" />Checklist</>}
                            name="Checklist"
                            onClick={() => setChosenElement('Checklist')}
                            active={chosenElement === 'Checklist'} />
                        <MenuItem disabled={isNew} content={<><Icon color="grey" className="clock outline" />Lifecycle</>} name="Lifecycle" onClick={() => setChosenElement('Lifecycle')} active={chosenElement === 'Lifecycle'} />
                        <MenuItem content={<><Icon color="grey" className="exclamation" />Problems</>} onClick={() => setChosenElement("Problems")} active={chosenElement === 'Problems'} name="Problems"/>
                        <MenuItem disabled={isNew} content={<><Icon color="grey" className="images" />Images</>} name="Images" onClick={() => setChosenElement('Images')} active={chosenElement === 'Images'} />
                        <MenuItem disabled={isNew} content={<><Icon color="grey" className="exchange" />Asset Transfer</>} name="Asset Transfer" onClick={() => setChosenElement('Moves')} active={chosenElement === 'Moves'} style={{ whiteSpace: 'nowrap' }} />
                    </Menu>
                </div>
            </div>

            {chosenElement === 'View' && <AssetDetails key={detailRefreshKey} changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Changelog' && <AssetHistoryList changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Checklist' && <AssetChecklistViewer setJustVerified={setJustVerified} changePage={changePage} {...pageArgs} />}
            {chosenElement === 'Lifecycle' && <AssetLifecycle />}
            {chosenElement === 'Problems' && <AssetProblems />}
            {chosenElement === 'Images' && <AssetImages inspectionImages={inspectionImages} />}
            {chosenElement === 'Moves' && <AssetMoveHistory
                iccName={assetData?.iccName}
                currentTeamId={assetData?.associatedTeam?.id ?? assetData?.associatedTeam}
                onAssetRefresh={() => { getNeedsVerification(); setDetailRefreshKey(k => k + 1); }}
            />}
        </>
    );

}
